"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BudPayButton;

var _react = _interopRequireDefault(require("react"));

var _useBudPayPayment = _interopRequireDefault(require("./useBudPayPayment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function BudPayButton(config) {
  var handleBudPayPayment = (0, _useBudPayPayment["default"])(config); // Button Styles

  var buttonStyles = {
    border: 'none',
    background: '#5018cd',
    color: '#ffffff',
    borderRadius: '6px',
    margin: '1rem',
    cursor: 'pointer'
  };

  var smallButtonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
    padding: '8px 16px',
    fontWeight: 500
  });

  var mediumButtonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
    padding: '16px 24px',
    fontWeight: 600
  });

  var largeButtonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
    padding: '22px 32px',
    fontWeight: 600
  }); // Select Button size from params or default


  var selectActiveButtonSize = function selectActiveButtonSize() {
    if (config.btnSize) {
      if (config.btnSize == 'small') return smallButtonStyles;
      if (config.btnSize == 'medium') return mediumButtonStyles;
      if (config.btnSize == 'large') return largeButtonStyles;
    } else {
      return mediumButtonStyles;
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return handleBudPayPayment();
    },
    style: selectActiveButtonSize()
  }, config.text));
}